<template>
  <div class="marketplace left">
    <div class="padding p-top">
      <h2>Premi</h2>
      <p>Riscattabili subito con punti.</p>
    </div>
    <div
      class="lista"
      @click="
          $router.push({
            name: 'Prodotto'
          })
        "
    >
      <img src="../assets/listapremi.png" />
    </div>

    <div class="padding">
      <h2>Offerte</h2>
      <p>Offerte dei nostri partner.</p>
    </div>
    <div class="lista">
      <img src="../assets/listapremi.png" @click="$router.push({
        name:'Prodotto'
      })" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Marketplace",
  components: {}
};
</script>

<style lang="less" scoped>
@keyframes enter {
  from {
    opacity: 0;
    transform: translate(0, 20%);
  }
  to {
    opacity: 1;
    transform: translate(0, 0%);
  }
}
.marketplace {
  opacity: 0;
  animation: enter 500ms 300ms forwards;
}
.padding {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
}
.p-top {
  padding-top: 30px;
}
.lista {
  width: 100%;
  overflow: auto;
  padding-left: 10px;
}
</style>
